import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { NgxMatTimepickerComponent } from './timepicker.component';
import { SvgIconModule } from '../../../../src/app/components/svg-icon/svg-icon.module';

@NgModule({
    imports: [
        CommonModule,
        MatInputModule,
        ReactiveFormsModule,
        FormsModule,
        MatIconModule,
        MatButtonModule,
        SvgIconModule,
    ],
  exports: [
    NgxMatTimepickerComponent
  ],
  declarations: [
    NgxMatTimepickerComponent
  ]
})
export class NgxMatTimepickerModule { }
